import { Grid, IconButton, InputAdornment, Typography } from "@mui/material"
import globalStyles from "../../Styles/ComponentStyles/global.module.scss"
import Astrict from "../../GlobalComponent/Astrict/Astrict"
import GlobalTextfield from "../../GlobalComponent/GlobalTextfield/GlobalTextfield"
import GlobalButton from "../../Utils/GlobalUtilsComponents/GlobalButton"
import { MuiOtpInput } from 'mui-one-time-password-input'
import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { UserContext, UserContextPayload } from "../../Context/UserDetailContext"
import agent from "../../service/api"
import { useSnackbar } from "../../GlobalComponent/GlobalSnackbar/GlobalSnackbar"
import { Visibility, VisibilityOff } from '@mui/icons-material';

type ChangePasswordProps = {
    /** When set (e.g. dialog close), Cancel calls this instead of browser back. */
    onCancel?: () => void
}

const ChangePassword = ({ onCancel }: ChangePasswordProps = {}) => {
    const { showSnackbar } = useSnackbar()
    const navigate = useNavigate()

    const { setFlagLoader, userDetail } = useContext(UserContext) as UserContextPayload
    const [verificationCodeSent, setVerificationCodeSent] = useState(false)
    const [otp, setOtp] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [formState, setFormState] = useState({
        password: "",
        confirm_password: ""
    })
    const [errors, setErrors] = useState({
        password: "",
        confirm_password: "",
        otp: "",
    });

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$.!%*#?&])[A-Za-z\d@$.!%*#?&]{8,}$/

    // useEffect(() => {
    //     sendVerificationCode()
    // }, [])

    const handleOtpChange = (newValue: string) => {
        setOtp(newValue);
        if (newValue.length === 6) {
            setErrors((prev) => ({ ...prev, otp: "" }));
        }
    };

    const handleChange = (field: string, value: string) => {
        setFormState((prev) => ({ ...prev, [field]: value }));

        if (field === "password" && passwordRegex.test(value)) {
            setErrors((prev) => ({ ...prev, password: "" }));
        }
        if (field === "confirm_password" && value === formState.password) {
            setErrors((prev) => ({ ...prev, confirm_password: "" }));
        }
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword)
    }

    const handleClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword)
    }

    const validatePasswordFields = () => {
        let isValid = true;
        const passwordError = !passwordRegex.test(formState.password)
            ? "Password must have at least 8 characters, one uppercase, one lowercase, one number, and one special character."
            : "";
        const confirmError =
            formState.password !== formState.confirm_password ? "Passwords do not match." : "";

        if (passwordError) isValid = false;
        if (confirmError) isValid = false;

        setErrors((prev) => ({
            ...prev,
            password: passwordError,
            confirm_password: confirmError,
        }));
        return isValid;
    };

    const validateForm = () => {
        if (!validatePasswordFields()) return false;
        if (otp.length !== 6) {
            setErrors((prev) => ({ ...prev, otp: "OTP must be 6 digits." }));
            return false;
        }
        setErrors((prev) => ({ ...prev, otp: "" }));
        return true;
    };

    const canSubmitVerify =
        formState.password.trim().length > 0 && formState.confirm_password.trim().length > 0;

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
            return;
        }
        navigate(-1);
    };

    const sendVerificationCode = async () => {
        try {
            setFlagLoader(true);
            const response = await agent.sendVerificationCodeAPI.get();
            console.log(response?.status, "response?.status")
            if (response?.status !== 401 && response?.status !== 400) {
                setVerificationCodeSent(true);
                setFlagLoader(false);
                showSnackbar("Verification code has been sent successfully on your email account", "success");
            } else {
                setFlagLoader(false);
                showSnackbar("Error sending code!", "error");
            }
        } catch (error) {
            setFlagLoader(false);
            console.log(error, "Error sending code");
        } finally {
            setFlagLoader(false);
        }
    };

    const handleVerifyClick = async () => {
        if (!validatePasswordFields()) {
            showSnackbar("Please resolve validation errors before submitting.", "error");
            return;
        }
        await sendVerificationCode();
    };

    const resetPassword = async () => {
        if (!validateForm()) {
            showSnackbar("Please resolve validation errors before submitting.", "error");
            return;
        }
        try {
            setFlagLoader(true);
            const payload = {
                ...formState,
                verification_code: otp
            }
            const response = await agent.changePasswordAPI.put(payload);
            if (response?.status !== 401 && response?.status !== 400) {
                setFlagLoader(false)
                setVerificationCodeSent(false)
                setFormState({
                    password: "",
                    confirm_password: ""
                })
                setOtp("")
                setErrors({ password: "", confirm_password: "", otp: "" })
                showSnackbar("Password changed successfully!", "success")
            } else {
                setFlagLoader(false)
                showSnackbar(response?.error?.message || "Error resetting password!", "error")
            }
        } catch (error) {
            setFlagLoader(false)
            console.log(error, "Error sending code")
        } finally {
            onCancel?.()
            setFlagLoader(false)
        }
    }

    return (
        <>
            <Grid item xs={12}>
                <Grid container direction={"column"} gap={3} overflow={"auto"}>
                    <Grid item xs={12}>
                        <Grid container direction={"column"} gap={"20px"}>
                            <Grid item className={`${globalStyles.changePwdFieldsWrapper}`}>
                                <Grid container>
                                    <Grid item xs={12} className={`${globalStyles.globalPFLabel}`}>
                                        <Typography component={'span'} className={`${globalStyles.globalPFTextfieldLabel}`}>
                                            Email <Astrict />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <GlobalTextfield
                                            variant="outlined"
                                            placeholder="Enter First Name"
                                            size="medium"
                                            fullWidth
                                            autoComplete="off"
                                            stylingClassName={`${globalStyles.globalPFTextfield}`}
                                            value={userDetail?.user_data?.user_email ? userDetail?.user_data?.user_email : ""}
                                            disabled
                                        // onChange={(e) => handleChange('firstname', e.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item className={`${globalStyles.changePwdFieldsWrapper}`}>
                                <Grid container>
                                    <Grid item xs={12} className={`${globalStyles.globalPFLabel}`}>
                                        <Typography component={'span'} className={`${globalStyles.globalPFTextfieldLabel}`}>
                                            New password <Astrict />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <GlobalTextfield
                                            variant="outlined"
                                            // placeholder="Enter New Password"
                                            size="medium"
                                            fullWidth
                                            autoComplete="new-password"
                                            stylingClassName={`${globalStyles.globalPFTextfield}`}
                                            type={showPassword ? "text" : "password"}
                                            value={formState.password}
                                            onChange={(e) => handleChange("password", e.target.value)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => handleClickShowPassword()}
                                                            edge="end"
                                                        >
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        {errors.password && <label className={globalStyles.changePwdErrorStyle}>{errors.password}</label>}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item className={`${globalStyles.changePwdFieldsWrapper}`}>
                                <Grid container>
                                    <Grid item xs={12} className={`${globalStyles.globalPFLabel}`}>
                                        <Typography component={'span'} className={`${globalStyles.globalPFTextfieldLabel}`}>
                                            Confirm new password <Astrict />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <GlobalTextfield
                                            variant="outlined"
                                            // placeholder="Confirm New Password"
                                            size="medium"
                                            fullWidth
                                            autoComplete="off"
                                            stylingClassName={`${globalStyles.globalPFTextfield}`}
                                            type={showConfirmPassword ? "text" : "password"}
                                            value={formState.confirm_password}
                                            onChange={(e) => handleChange('confirm_password', e.target.value)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => handleClickShowConfirmPassword()}
                                                            edge="end"
                                                        >
                                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        {errors.confirm_password && <label className={globalStyles.changePwdErrorStyle}>{errors.confirm_password}</label>}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {verificationCodeSent && (
                        <Grid item xs={12}>
                            <Grid container direction={"column"} spacing={2}>
                                <Grid item>
                                    <Grid container direction={"column"} gap={"5px"}>
                                        <Grid item>
                                            <Grid container alignItems={"center"} justifyContent={"space-between"}>
                                                <Grid item>
                                                    <span className={`${globalStyles.globalPFTextfieldLabel}`}>Verification Code</span>
                                                </Grid>
                                                <Grid item>
                                                    <span className={globalStyles.changePwdResendCode} onClick={() => sendVerificationCode()}>Resend Verification Code</span>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <MuiOtpInput className={globalStyles.otpBoxes} value={otp} length={6} onChange={handleOtpChange} />
                                    {errors.otp && <label className={globalStyles.changePwdErrorStyle}>{errors.otp}</label>}
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <Grid container spacing={2} justifyContent="center" alignItems="center">
                            <Grid item xs={12} sm="auto">
                                <GlobalButton
                                    value="Cancel"
                                    variant="outlined"
                                    fullWidth
                                    sx={{ minHeight: 45, textTransform: "capitalize" }}
                                    onClick={handleCancel}
                                />
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                {!verificationCodeSent ? (
                                    <GlobalButton
                                        value="Verify"
                                        disabled={!canSubmitVerify}
                                        fullWidth
                                        className={globalStyles.changePasswordButton}
                                        onClick={() => { void handleVerifyClick() }}
                                    />
                                ) : (
                                    <GlobalButton
                                        value="Change Password"
                                        fullWidth
                                        className={globalStyles.changePasswordButton}
                                        onClick={() => { resetPassword() }}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ChangePassword
